var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"developing-state"},[_c('empty-state',{attrs:{"title":_vm.title,"description":_vm.description,"icon":_vm.icon,"icon-size":_vm.iconSize}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }